import {
  AccumulativeShadows,
  Environment,
  RandomizedLight,
} from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { Group } from "three";

function Sphere({ ...props }) {
  const ref = useRef<Group>(null);

  useFrame((state) => {
    const t = state.clock.getElapsedTime();
    ref.current!.rotation.set(Math.cos(t / 16) / 32, Math.sin(t / 8) / 16, 0);
  });

  return (
    <group ref={ref} position={[0, -0.5, 0]}>
      <AccumulativeShadows
        temporal
        frames={40}
        color="indianred"
        colorBlend={0.5}
        opacity={0.8}
        scale={12}
        alphaTest={0.85}
      >
        <RandomizedLight
          amount={2}
          radius={5}
          ambient={0.5}
          position={[5, 5, -5]}
          bias={0.001}
        />
      </AccumulativeShadows>
      <Environment preset="forest" />
      <mesh {...props} castShadow>
        <sphereGeometry args={[0.5, 16, 16]} />
        <meshStandardMaterial
          metalness={0.5}
          roughness={0.75}
          color={"indianred"}
        />
      </mesh>
    </group>
  );
}
export default Sphere;
